import { IFrameNavButton } from "../atoms/IFrameNavButton";
import { usePerformanceButtonAdapter } from "adapters/performance";

const PerformanceButton = () => {
  const props = usePerformanceButtonAdapter();
  return <IFrameNavButton {...props} />;
};

export { PerformanceButton };
